export function formatToUSD(amount: number): string {
  const amountStr = amount.toString();
  const hasCents = amountStr.includes('.');
  const formattedAmount = hasCents ? amount.toFixed(2) : amount + '.00';
  return '$' + formattedAmount;
}
